import { putJSONexpectText } from "../netzwerk/FetchWithToken";

export const saveSettings = (which, value) => {
	putJSONexpectText("/settings/" + which, value).then(response => {
		if (!response.ok) {
			/* Nicht besonders schick die (englische) Antwort vom Server
			 * anzuzeigen, aber immerhin steht dort irgendwo, was
			 * eigentlich passiert ist.
			 * Wenn alles gut geht, werden die neuen Einstellungen sowieso
			 * vom Server verschickt (socket.io).
			 */
			response.text().then(text => alert(text));
		}
	});
};
